import DOMPurify from "dompurify";

export function sanitizeHtml(html) {
  return DOMPurify.sanitize(html || "", { ADD_ATTR: ["target"] });
}

export function sanitizeStyle(html) {
  return DOMPurify.sanitize(html || "", {
    FORCE_BODY: true,
    ALLOWED_TAGS: ["style"],
    ALLOWED_ATTR: [],
  });
}
